"use client";
import dynamic from "next/dynamic";

const TextEditor = dynamic(
  () => import("@/components/tools/GrammarCheckerEditor/TextEditor"),
  { ssr: false },
);

const GrammarCheckerCoreSection = () => {
  return (
    <div className="my-6 rounded-[8px] bg-[#FFFFFF]">
      <TextEditor />
    </div>
  );
};
export default GrammarCheckerCoreSection;
